import type { ReactNode } from "react";

import styles from "./flow-header.module.css";

type FlowHeaderProps = {
	className?: string;
	description: ReactNode;
	title: ReactNode;
};
export function FlowHeader({ className, description, title }: FlowHeaderProps): ReactNode {
	return (
		<div className={className}>
			<h1 className={styles.title}>{title}</h1>
			<p className="body-1">{description}</p>
		</div>
	);
}
